module.exports = __webpack_public_path__ + "static/media/mobile.0b8770b8.jpg";